
import React from 'react';
import { Award, Gift, DollarSign } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

const PointsSystem: React.FC = () => {
  const examples = [
    {
      title: "Points Accumulation",
      icon: Award,
      description: "Earn points for referral actions",
      examples: [
        "1 Referral Sign-up = 100 points",
        "Referral Purchase = 50 points",
        "Monthly Active Referral = 25 points"
      ]
    },
    {
      title: "Flexible Redemption",
      icon: Gift,
      description: "Multiple redemption options",
      examples: [
        "Convert points to cash rewards",
        "Redeem for gift cards",
        "Integrate with existing loyalty programs"
      ]
    },
    {
      title: "Recurring Benefits",
      icon: DollarSign,
      description: "Ongoing earning potential",
      examples: [
        "Monthly points for active referrals",
        "Points for repeat purchases",
        "Bonus points for milestones"
      ]
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-2xl font-bold text-[#1A1F2C] mb-4">
            Flexible Points-Based Referral System
          </h2>
          <p className="text-gray-600 max-w-3xl mx-auto">
            Our dynamic points engine allows businesses to customize how customers earn and redeem points,
            providing a highly adaptable structure that aligns with existing loyalty programs, incentive models, or cash rewards.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mt-12">
          {examples.map((item, index) => (
            <Card key={index} className="bg-white shadow-md hover:shadow-lg transition-shadow">
              <CardContent className="p-6">
                <div className="flex flex-col items-center text-center">
                  <div className="bg-blue-50 p-3 rounded-full mb-4">
                    <item.icon className="h-8 w-8 text-primary-blue" />
                  </div>
                  <h3 className="text-xl font-semibold mb-3">{item.title}</h3>
                  <p className="text-gray-600 mb-4">{item.description}</p>
                  <ul className="space-y-2 text-sm text-gray-500">
                    {item.examples.map((example, idx) => (
                      <li key={idx} className="flex items-center justify-center">
                        <span className="w-2 h-2 bg-primary-blue rounded-full mr-2"></span>
                        {example}
                      </li>
                    ))}
                  </ul>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PointsSystem;
